// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app-container[data-v-7ba5bd90] {\n  display: flex;\n  flex-direction: column;\n  min-height: calc(100vh - 3rem);\n}\n.copyright[data-v-7ba5bd90] {\n  font-size: 0.875rem;\n  margin-top: auto;\n  color: var(--gray);\n  justify-content: center;\n  height: 3rem;\n  display: flex;\n  align-items: center;\n}\n", ""]);
// Exports
module.exports = exports;
